(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instax-products-range"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function toArray(list) { return Array.prototype.slice.call(list); }

  function getTabsContext(navTabsEl) {
    const links = toArray(navTabsEl.querySelectorAll('.nav-link[href^="#"]'));
    let scope = navTabsEl.parentElement;
    let tabContent = null;
    while (scope && !tabContent) {
      tabContent = scope.querySelector(':scope .tab-content');
      scope = scope.parentElement;
    }
    if (!tabContent) tabContent = document.querySelector('.tab-content');
    const panes = tabContent ? toArray(tabContent.querySelectorAll('.tab-pane')) : [];
    return { links, panes, tabContent };
  }

  function activateTabByHash(navTabsEl, hash, options) {
    const { links, panes } = getTabsContext(navTabsEl);
    if (!links.length || !panes.length) return;
    const targetId = hash && hash.startsWith('#') ? hash.slice(1) : hash;
    const targetPane = panes.find(p => p.id === targetId);
    const targetLink = links.find(a => a.getAttribute('href') === '#' + targetId);
    if (!targetPane || !targetLink) return;
    links.forEach(a => {
      a.classList.remove('active');
      a.setAttribute('aria-selected', 'false');
      a.parentElement?.classList.remove('active');
      a.setAttribute('role', 'tab');
      a.setAttribute('tabindex', '-1');
    });
    panes.forEach(p => {
      p.classList.remove('active', 'in', 'show');
      p.setAttribute('aria-hidden', 'true');
      p.setAttribute('role', 'tabpanel');
    });
    targetLink.classList.add('active');
    targetLink.setAttribute('aria-selected', 'true');
    targetLink.setAttribute('tabindex', '0');
    targetLink.parentElement?.classList.add('active');
    targetPane.classList.add('active');
    targetPane.setAttribute('aria-hidden', 'false');
    if (targetPane.classList.contains('fade')) {
      targetPane.offsetWidth;
      targetPane.classList.add('in', 'show');
    }
    if (options && options.focus) targetLink.focus();
  }

  function initTabGroup(navTabsEl) {
    const { links } = getTabsContext(navTabsEl);
    if (!links.length) return;
    navTabsEl.setAttribute('role', 'tablist');
    navTabsEl.addEventListener('click', function (e) {
      const a = e.target.closest('.nav-link[href^="#"]');
      if (!a || !navTabsEl.contains(a)) return;
      const href = a.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      e.preventDefault();
      if (history && history.pushState) history.pushState(null, '', href);
      else location.hash = href;
      activateTabByHash(navTabsEl, href, { focus: false });
    });
    navTabsEl.addEventListener('keydown', function (e) {
      const KEY_LEFT = 37, KEY_RIGHT = 39, KEY_UP = 38, KEY_DOWN = 40, KEY_HOME = 36, KEY_END = 35;
      const current = document.activeElement.closest('.nav-link');
      if (!current || !navTabsEl.contains(current)) return;
      const items = links;
      const currentIndex = items.indexOf(current);
      if (currentIndex === -1) return;
      let nextIndex = null;
      switch (e.keyCode) {
        case KEY_LEFT: case KEY_UP: nextIndex = (currentIndex - 1 + items.length) % items.length; break;
        case KEY_RIGHT: case KEY_DOWN: nextIndex = (currentIndex + 1) % items.length; break;
        case KEY_HOME: nextIndex = 0; break;
        case KEY_END: nextIndex = items.length - 1; break;
        default: return;
      }
      e.preventDefault();
      const next = items[nextIndex];
      if (next) {
        const href = next.getAttribute('href');
        if (history && history.pushState) history.pushState(null, '', href);
        else location.hash = href;
        activateTabByHash(navTabsEl, href, { focus: true });
      }
    });
    var initialHash = window.location.hash;
    const hrefs = links.map(a => a.getAttribute('href'));
    const matchHash = initialHash && hrefs.includes(initialHash) ? initialHash : null;
    if (matchHash) {
      activateTabByHash(navTabsEl, matchHash, { focus: false });
    } else {
      const preActive = links.find(a => a.classList.contains('active')) || links[0];
      if (preActive) activateTabByHash(navTabsEl, preActive.getAttribute('href'), { focus: false });
    }
  }

  window.addEventListener('hashchange', function () {
    const hash = window.location.hash;
    toArray(document.querySelectorAll('.nav.nav-tabs')).forEach(function (ul) {
      const links = toArray(ul.querySelectorAll('.nav-link[href^="#"]'));
      if (links.some(a => a.getAttribute('href') === hash)) activateTabByHash(ul, hash, { focus: true });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    toArray(document.querySelectorAll('.nav.nav-tabs')).forEach(initTabGroup);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
